export const calendarEvents = [
  {
    name: 'Event',
    color: '#21AC69'
  },
  {
    name: 'Community Event',
    color: '#D06CFF'
  },
  {
    name: 'Charity Event',
    color: '#814EED'
  },
  {
    name: 'Streamer Live',
    color: '#E12F2F'
  }
]
